import RefreshAnimated from '@/src/components/Commons/RefreshAnimated';
import { FundWithDetailsEntity, SwapOfferEntity } from '@/src/lib/MayzSmartDB';
import { useTokensStore } from '@/src/store/global';
import { formatPercentage } from '@/src/lib/SmartDB/Commons/formatters';
import { showADA_Amount_NotRounded, showToken_Amount_NotRounded, showToken_Price_NotRounded } from '@/src/store/global/tokensStoreModelHelpers';
import { BPx1e3_DECIMALS, MIN_TIME_BETWEEN_REFRESHES_MS } from '@/src/lib/SmartDB/Commons/Constants/constants';
import styles from './Conversion.module.scss';

interface ConversionProps {
    showRefresh: boolean;
    showValid: boolean;
    isBuy: boolean;
    fund: FundWithDetailsEntity;
    swapOffer: SwapOfferEntity | undefined;
    commission: bigint;
    classNameStyle?: string;
    price_Adjusted_For_Fee?: bigint;
}

export default function Conversion(props: ConversionProps) {
    //--------------------------------------
    const { isBuy, fund, swapOffer, commission, classNameStyle, price_Adjusted_For_Fee } = props;
    //--------------------------------------
    const tokensStore = useTokensStore();
    //--------------------------------------
    return (
        <section className={`${styles.conversionSection} ${classNameStyle !== undefined ? styles[classNameStyle] : styles.dark}`}>
            <div className={styles.conversionItem}>
                <div className={styles.text}>Base Price</div>
                <p className={styles.value}>
                    {tokensStore.isAddingTokens === false
                        ? showToken_Price_NotRounded(tokensStore, fund.getNET_id_CS(), fund.fdFundFT_TN_Hex)
                        : showADA_Amount_NotRounded(tokensStore, undefined)}
                </p>
            </div>
            <div className={styles.conversionItem}>
                <p className={styles.text}>Fee</p>
                <p className={styles.value}>
                    {swapOffer !== undefined ? (
                        <>
                            {formatPercentage(swapOffer.sodAskedCommission_InBPx1e3, 2, false, BPx1e3_DECIMALS)} (
                            {isBuy ? (
                                <>
                                    {tokensStore.isAddingTokens === false
                                        ? showToken_Amount_NotRounded(tokensStore, commission, fund.getNET_id_CS(), fund.fdFundFT_TN_Hex)
                                        : showADA_Amount_NotRounded(tokensStore, undefined)}
                                </>
                            ) : (
                                <>{tokensStore.isAddingTokens === false ? showADA_Amount_NotRounded(tokensStore, commission) : showADA_Amount_NotRounded(tokensStore, undefined)}</>
                            )}
                            )
                        </>
                    ) : null}
                </p>
            </div>

            <div className={styles.conversionItem}>
                <p className={styles.text}>Final Price</p>
                <p className={styles.value}>
                    {swapOffer !== undefined
                        ? tokensStore.isAddingTokens === false
                            ? showADA_Amount_NotRounded(tokensStore, price_Adjusted_For_Fee)
                            : showADA_Amount_NotRounded(tokensStore, undefined)
                        : null}
                </p>
            </div>

            {props.showValid === true && (
                <div className={styles.conversionItem}>
                    <div className={styles.text}>
                        Valid for
                        {props.showRefresh === true &&
                            tokensStore.getTokenValidity(fund.getNET_id_CS(), fund.fdFundFT_TN_Hex) !== undefined &&
                            tokensStore.getTokenValidity(fund.getNET_id_CS(), fund.fdFundFT_TN_Hex)! < MIN_TIME_BETWEEN_REFRESHES_MS / 1000 && (
                                <RefreshAnimated tokensStore={tokensStore} />
                            )}
                    </div>
                    <p className={styles.value}>{tokensStore.showTokenValidity(fund.getNET_id_CS(), fund.fdFundFT_TN_Hex)}</p>
                </div>
            )}
        </section>
    );
}
